<script setup lang="ts">
/**
 * Toast Info
 * --------------------------------
 * Info toast with blue background
 */

const { toast } = defineProps<{
    toast: Toast;
}>();
</script>

<template>
    <Toast :toast="toast" class="bg-accent-1 text-white">
        <template #icon>
            <Icon name="tot:info" class="size-4" />
        </template>
        <div v-html="toast.message" />
    </Toast>
</template>
